var React = require('react');

function CheckMarkPrimary (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#F45C25","key":0}),React.createElement("path",{"d":"M7 12L10.5 15.5L17.5 9","stroke":"white","strokeWidth":"2","key":1})]);
}

CheckMarkPrimary.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckMarkPrimary;

CheckMarkPrimary.default = CheckMarkPrimary;
